<h2 class="common {{ extraClasses }}">{{ headingText }}</h2>
